import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  holiday: (state: State) => state.holiday,
  holidayInitData: (state: State) => state.holidayInitData,
  holidays: (state: State) => state.holidays,
  holidayCount: (state: State) => state.holidayCount,
} as GetterTree<State, any>;
